import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PosQrCodeComponent } from './pos-qr-code.component';



@NgModule({
  declarations: [
    PosQrCodeComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    PosQrCodeComponent
  ]
})
export class PosQrCodeModule { }
